@if (plotlyData() && layout()) {
  <plotly-plot
    class="flex-1 min-h-0 w-full"
    [divId]="plotId"
    [data]="plotlyData()"
    [layout]="layout()"
    [config]="config"
    [updateOnDataChange]="true"
    [updateOnLayoutChange]="true"
    [useResizeHandler]="true"
    [style]="{ position: 'relative', width: '100%', height: '100%', display: 'block' }"
  ></plotly-plot>
}